import { render, staticRenderFns } from "./_ListTaches.vue?vue&type=template&id=74e900db&scoped=true&"
import script from "./_ListTaches.vue?vue&type=script&lang=ts&"
export * from "./_ListTaches.vue?vue&type=script&lang=ts&"
import style0 from "./_ListTaches.vue?vue&type=style&index=0&id=74e900db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e900db",
  null
  
)

export default component.exports